import React from 'react'
import Select from 'react-select'

var SearchBar = React.createClass({
  getInitialState(){
    return {
      categories: [{
        value: 'all',
        label: 'None'
      }]
    }
  },
  handleSearchChange: function() {
    this.props.onUserSearchInput(this.refs.filterTextInput.value)
  },
  handleSelectChange: function(item){
    this.value = item.value
    this.props.onUserSelectInput(item.value)
  },
  componentDidMount(){
    this.props.player.populateUsedCategories(() => {
      this.setState({
        categories: _.union(this.state.categories, _.map(this.props.player.usedCategories, function(cat){
          return{
            value: cat.catId,
            label: cat.catName
          }
        }))
      })
    })
  },
  getOptions: function(){
    return this.state.categories
  },
  render: function() {
    var options = this.getOptions()
    if(!this.value) this.value = null
    return (
      <form>
        <input className="form-control" aria-label="Search Input" type="text" placeholder="Search..." value={this.props.filterText} ref="filterTextInput" onChange={this.handleSearchChange}/>
          <Select
              name="category"
              aria-label="Category Dropdown"
              value={this.value}
              options={options}
              ref="category"
              placeholder="Select Category"
              searchable={true}
              clearable={false}
              onChange={this.handleSelectChange}
          />
      </form>
    )
  }
})

module.exports = SearchBar



// WEBPACK FOOTER //
// ./src/components/SearchBar.jsx